export default "/Frontend/dist/doc-fallback-white.f209d85f14ce6cfa7abf5d576a3e806c.svg";